module.exports = __webpack_public_path__ + "static/media/fintech-logo-white-version.08337c15.png";